import React from 'react';

export type LewouhmartLogoMarkProps = {
  /** Typically storefront brand green (e.g. #059669). */
  brandPrimary: string;
  /** Typically storefront accent orange (e.g. #ea580c). */
  navAccent: string;
  className?: string;
  /** CSS px width/height (square). */
  size?: number;
};

/**
 * Vector LM monogram on a rounded square: gradient matches “Lewouh” + “mart” wordmark colors.
 */
export function LewouhmartLogoMark({
  brandPrimary,
  navAccent,
  className = '',
  size = 36,
}: LewouhmartLogoMarkProps) {
  const gradId = React.useId().replace(/:/g, '');

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={`shrink-0 ${className}`.trim()}
      aria-hidden
    >
      <defs>
        <linearGradient id={gradId} x1="8%" y1="10%" x2="92%" y2="90%">
          <stop offset="0%" stopColor={brandPrimary} />
          <stop offset="100%" stopColor={navAccent} />
        </linearGradient>
      </defs>
      <rect
        x="3"
        y="3"
        width="94"
        height="94"
        rx="22"
        fill={`url(#${gradId})`}
      />
      <path
        d="M 28 31 V 69 H 58"
        fill="none"
        stroke="#ffffff"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M 44 69 V 35 L 54 52.5 L 64 35 V 69"
        fill="none"
        stroke="#ffffff"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="73" cy="72" r="5" fill={brandPrimary} opacity={0.98} />
    </svg>
  );
}

export default LewouhmartLogoMark;
